// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-navigation-base__sidebar-icon-favorites {
  color: var(--g-color-base-misc-heavy-hover);
}
.dl-navigation-base__sidebar-icon-widgets {
  color: var(--g-color-base-brand);
}
.dl-navigation-base__sidebar-icon-datasets {
  color: var(--g-color-base-positive-heavy);
}
.dl-navigation-base__sidebar-icon-dashboards, .dl-navigation-base__sidebar-icon-root, .dl-navigation-base__sidebar-icon-personal-folder {
  color: var(--g-color-text-warning-heavy);
}
.dl-navigation-base__sidebar-icon-connections {
  color: var(--g-color-text-link-visited);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Base/NavigationBase.scss"],"names":[],"mappings":"AACI;EACI,2CAAA;AAAR;AAGI;EACI,gCAAA;AADR;AAII;EACI,yCAAA;AAFR;AAKI;EAGI,wCAAA;AALR;AAQI;EACI,uCAAA;AANR","sourcesContent":[".dl-navigation-base__sidebar-icon-favorites {\n  color: var(--g-color-base-misc-heavy-hover);\n}\n.dl-navigation-base__sidebar-icon-widgets {\n  color: var(--g-color-base-brand);\n}\n.dl-navigation-base__sidebar-icon-datasets {\n  color: var(--g-color-base-positive-heavy);\n}\n.dl-navigation-base__sidebar-icon-dashboards, .dl-navigation-base__sidebar-icon-root, .dl-navigation-base__sidebar-icon-personal-folder {\n  color: var(--g-color-text-warning-heavy);\n}\n.dl-navigation-base__sidebar-icon-connections {\n  color: var(--g-color-text-link-visited);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
